import { HttpClient } from '@angular/common/http';
import { Injectable, Output, EventEmitter, Inject, Optional } from '@angular/core';
import { map } from "rxjs/operators";
/*
  Generated class for the SwiftimmoTemplateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

declare var autobahn:any;
declare var template_provider_autobahn:any;

export class Template {
    constructor(
        public id: string,
        public name: string,
        public description: string,
        public language: string,
        public file: string
    ) {}
}
export class Sample {
    constructor(
        public id: string,
        public name: string,
        public description: string,
        public language: string,
        public content: any
    ) {}
}
export class Mapping {
    constructor(
        public id: string,
        public name: string,
        public description: string,
        public language: string,
        public templateid: string,
        public sampleid: string,
        public mappings: any
    ) {}
}

export interface SNResponse {
    success: boolean;
}
export interface TemplateResponse extends SNResponse {
    templates: Template[]
}
export interface SampleResponse extends SNResponse {
    samples: Sample[]
}
export interface MappingResponse extends SNResponse {
    mappings: Mapping[]
}
export interface DocumentEvent {
    documentid: string;
    pdf: string;
}

@Injectable()
export class SwiftimmoTemplateProvider {

    templates: Template[];
    samples: Sample[];
    mappings: Mapping[];
    templatesById: {};
    samplesById: {};
    mappingsById: {};
    language: string = 'fr';
    connection: any;
    wampsession: any;
    wampsubscription: any = null;
    private serviceurl: string = '';
    private serviceprotocol: string = 'http';
    private servicehost: string = '';
    private serviceuser: string = 'certinergie';
    private servicepass: string = 'certinergie';
    private authorization: string = '';
    private wsprotocol: string = 'ws';
    
    @Output() messageEvent = new EventEmitter<DocumentEvent>();
    
  constructor(public http: HttpClient,@Inject(Window) private window: Window,@Inject(Document) private document: Document,@Optional() url: string) {
    console.log('Hello SwiftimmoTemplateProvider Provider');
    console.log(this.window);
    this.url = this.document.domain;
    this.openWamp();
  }
  
  set url(url: string)
  {
      console.log('set url ' + url);
      var parser = document.createElement('a');
      parser.href = url;
      this.serviceurl = url;
      this.servicehost = parser.host;
      this.serviceprotocol = parser.protocol;
      console.log('url ' + this.serviceurl + ' host ' + this.servicehost + ' protocol ' + this.serviceprotocol);
      if (this.serviceprotocol == 'https:')
      {
          // set WebSocket Secured
          this.wsprotocol = 'wss';
      }
  }
  
  get url(): string
  {
      return this.serviceurl;
  }

  openWamp()
  {
      this.connection = new autobahn.Connection({url: this.wsprotocol + '://' + this.servicehost + '/ws/', realm: 'template'});
      template_provider_autobahn = this;
      this.connection.onopen = function (session,details) {
          template_provider_autobahn.wampsession = session;
       };
      this.connection.open();
  }
  
  onWampEvent(args)
  {
      console.log('WAMP event');
      console.log(args);
      let document = args[0];
      console.log('Received document ' + document.documentid + ' event');
      if (document.success === true)
      {
          // Send event to confirm document availability
          let message: DocumentEvent = {
              documentid: document.documentid,
              pdf: document.pdf
          };
          template_provider_autobahn.messageEvent.emit(message);
      }
  }
  
  getTemplates()
  {
      return this.http.get<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/template')
          .pipe(map(response => {
              this.templatesById = {};
              for (let template of response.templates)
              {
                  this.templatesById[template.id] = template;
              }
              this.templates = response.templates;
              return response.templates;
          }));
  }
  
  addTemplate()
  {
      // Create a new template
      return this.http.post(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/template',{});
  }
  
  updateTemplate(template)
  {
      return this.http.put<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/template/' + template.id,template)
      .pipe(map(response => {
          this.templatesById[response.template.id] = response.template;
      }));      
  }
  
  getSamples()
  {
      console.log('getSamples');
      return this.http.get<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/sample')
          .pipe(map(response => {
              console.log('getSamples response');
              this.samplesById = {};
              for (let sample of response.samples)
              {
                  this.samplesById[sample.id] = sample;
              }
              this.samples = response.samples;
              return response.samples;
          }));
  }
  
  getSample(sampleid)
  {
      if (typeof this.samplesById[sampleid] == 'undefined')
      {
          return false;
      }
      return this.samplesById[sampleid];
  }
  
  addSample()
  {
      // Create a new sample
      return this.http.post(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/sample',{});
  }
  
  updateSample(sample)
  {
      return this.http.put<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/sample/' + sample.id,sample)
      .pipe(map(response => {
          this.samplesById[response.sample.id] = response.sample;
      }));      
  }
  
  getMappings()
  {
      console.log('getMappings');
      return this.http.get<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/mapping')
          .pipe(map(response => {
              console.log('getMappings response');
              this.mappingsById = {};
              for (let mapping of response.mappings)
              {
                  this.mappingsById[mapping.id] = mapping;
              }
              this.mappings = response.mappings;
              return response.mappings;
          }));
  }

  addMapping()
  {
      // Create a new sample
      return this.http.post(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/mapping',{});
  }
  
  updateMapping(mapping)
  {
      return this.http.put<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/fr/mapping/' + mapping.id,mapping)
      .pipe(map(response => {
          this.mappingsById[response.mapping.id] = response.mapping;
      }));      
  }

  makeDocument(templateid,type,content)
  {
      return this.http.post<any>(this.serviceprotocol + '//' + this.servicehost + '/api/v1/certinergie/' + this.language + '/template/' + templateid + '/document/' + type,content)
      .pipe(map(response => {
          // Subscribe to event containing the job id
          if (this.wampsubscription !== null)
          {
              // Unsubscribe
              this.wampsession.unsubscribe(this.wampsubscription);
          }
          this.wampsession.subscribe('two4tek.template.pdf.' + response.documentid.replace(/-/g,'.'), this.onWampEvent).then(
                  function (subscription) {
                      template_provider_autobahn.wampsubscription = subscription;
                  }
               );
          console.log('makeDocument response');
          console.log(response);
          return response.documentid;
      }));      
  }
}



// WEBPACK FOOTER //
// ./src/providers/swiftimmo-template/swiftimmo-template.ts